<template>
  <el-container style="height: 100%;" class="page-aside">
    <el-header class="el-head" style="height: 60px;">
      <Head @toggleCollapse="navcollapse" :isCollapse="isCollapse"/>
    </el-header>
    <el-container>
      <el-aside width="auto">
   
        <!-- :default-active="$route.meta.module || $route.path" -->
        <el-menu
          :default-openeds="open"
          :default-active="sliderActiveIndex"
          :unique-opened="sigle"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
        >
          <p class="aside-title">
            <span>{{$t('Header.nav_title1')}}</span>
            <span>{{$t('Header.nav_title2')}}</span>
          </p>
          <el-submenu :index="String(index)" v-for="(item, index) in slider" :key="index">
            <template slot="title">
              <i :class="item.module_icon"></i>
              <span slot="title">{{ item.label }}</span>
            </template>
            <el-menu-item-group v-if="item.children && item.children.length > 0">
              <el-menu-item
                :index="index +'-'+ (iIndex + 1)"
                v-for="(iItem, iIndex) in item.children"
                :key="iIndex"
              >
                <!-- <router-link :to="{path:iItem.module_markurl}" tag="div">{{ iItem.label }}</router-link> -->
                <div
                  @click="linkToPage(iItem.module_markurl, iItem.id, iItem.activeIndex, item.index, iItem)"
                  class="padding_40"
                >{{ iItem.label }}</div>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <slot></slot>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import Head from "../common/Header.vue";
export default {
  name: "pageNav",
  // props: ["slider", "openMenu"],
  props: ["openMenu"],
  data() {
    return {
      sigle: true,
      isCollapse: false
    };
  },
  components: {
    Head
  },
  created() {
    this.open = this.openMenu;
  },
  methods: {
    linkToPage(url, id, index, open, item) {
      this.$Tool.setStorage("module_id", id);
      this.$store.dispatch("setModuleId", id);
      this.$Tool.setStorage("sliderActiveIndex", index);
      this.$store.dispatch("setActiveIndex", index);

      if (item && item.children && item.children.length > 0) {
        this.$Tool.setStorage("innerSlider", item.children);
        this.$store.dispatch("setInnerSlider", item.children);
      } else {
        this.$Tool.removeStorage("innerSlider");
        this.$store.dispatch("setInnerSlider", []);
      }
 
      if (open != this.$store.state.openMenu[0]) {
        this.$Tool.setStorage("openMenu", ["" + open]);
        this.$store.dispatch("setOpenMenu", ["" + open]);
      }
      this.$router.push({ path: url });
    },
    handleOpen(key) {
      this.open = [key];
    },
    navcollapse(v) {
      this.isCollapse = v;
    },
    handleClose(key, keyPath) {
      (() => {})(key, keyPath);
    }
  },
  watch: {
    // slider(n,o){
    //   this.slider=n;
    //   (() => {})(n,334545)
    // }
  },
  computed: {
    slider: {
      get: function() {
        
        return this.$store.state.Slider;
      },
      set: function() {}
    },
    sliderActiveIndex() {
      return this.$store.state.sliderActiveIndex;
    },
    open: {
      get: function() {
        return this.$store.state.openMenu;
      },
      set: function() {}
    }
  }
};
</script>

<style lang="less">
.el-aside .el-menu:not(.el-menu--collapse) {
  width: 235px;
}
.el-aside .el-menu--collapse .aside-title {
  padding: 20px 0px 20px 10px;
  span {
    text-align: center;
    font-size: 14px;
    display: inline-block;
    width: 32px;
  }
}
.el-menu-item-group > ul {
  background-color: rgba(4, 5, 6, 0.6);
}
.page-aside {
  .el-submenu__title {
    color: #909399;
    height: 40px;
    line-height: 40px;
  }
  .el-submenu__title:hover {
    color: #fff;
    i {
      color: #fff;
    }
  }
  .el-menu-item {
    color: #909399;
    &.is-active {
      color: #fff;
    }
  }
  .aside-title {
    color: #909399;
    font-size: 16px;
    height: 60px;
    padding: 20px 0px 20px 25px;
  }
  .el-submenu__title {
    font-size: 13px;
    span {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .el-submenu .el-menu-item {
    height: 45px;
    line-height: 45px;
  }
  .el-menu-item:hover {
    color: #fff;
  }
}
.el-header {
  padding: 0px;
}
.page-aside .el-submenu .el-menu-item .router-link-exact-active {
  color: #fff;
}
</style>
